import Axios from "axios";

export function getAxios(token) {
  return Axios.create({headers: {Authorization: `Bearer ${token}`}});
}
